module.exports = __webpack_public_path__ + "static/media/supportroll.63877438.webp";